// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1__j9","cls2":"SuggestionReason-cls2__5R SuggestionReason-cls1__j9"};